const trackSignInClicked = () => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'LoginClicked',
  });
};

export default trackSignInClicked;
